import PaneInfo from './PaneInfo';
export default PaneInfo;